export * from './lib/logo';
